import { useQuery, UseQueryResult } from 'react-query';
import type { WorkoutCalendar } from 'types/generated/models/WorkoutCalendar';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface UseWorkoutsCalendarParams {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
}

function useWorkoutsCalendar({
  startDate,
  endDate,
  enabled = true,
}: UseWorkoutsCalendarParams = {}): UseQueryResult<{ data: WorkoutCalendar[] }> {
  return useQuery(
    ['workouts', 'calendar', startDate, endDate],
    () =>
      client.get(
        `workouts/calendar/?${encodeUrlParams({
          start_date: startDate as string,
          end_date: endDate as string,
        })}`,
      ),
    {
      enabled: enabled && !!startDate && !!endDate && endDate >= startDate,
    },
  );
}

export default useWorkoutsCalendar;
